export default __webpack_public_path__ + "navigation-examples-location-snapping-960-12411b66c6691e0ec8ee1252b2772087.png";